// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Bf","landingPageVideo":"Cf","play":"Df","iframeVideo":"Ef","playHidden":"Ff","playVisible":"Gf","fullwidth":"Hf"};